<script setup lang="ts">
import { Clock, Unlink, WifiOff } from 'lucide-vue-next'

const props = defineProps<{
  reason: 'expired' | 'not_found' | 'unavailable'
}>()

const content = {
  expired: {
    icon: Clock,
    heading: 'This link has expired',
    message: 'The link you followed is no longer active. Please contact us if you need a new one.',
  },
  not_found: {
    icon: Unlink,
    heading: 'Link not found',
    message: "This link doesn't exist. Please check the URL or contact us.",
  },
  unavailable: {
    icon: WifiOff,
    heading: 'Temporarily unavailable',
    message: 'Please try again in a moment or contact us on 1300 045 047.',
  },
} as const

const { icon: Icon, heading, message } = content[props.reason] ?? content.not_found
</script>

<template>
  <div class="bg-background flex min-h-screen items-center justify-center px-4">
    <div class="max-w-sm space-y-4 text-center">
      <Icon class="mx-auto size-12 text-amber-500" />
      <h1 class="text-xl font-bold">{{ heading }}</h1>
      <p class="text-muted-foreground text-sm">{{ message }}</p>
      <p class="text-sm font-medium">Call us on 1300 045 047</p>
    </div>
  </div>
</template>
